import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {SearchService} from '../../search/search.service';
import {tap} from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class ObjectExistsGuard implements CanActivate {

  constructor(private searchService: SearchService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.hasRequiredParams(route) && this.hasValidParams(route)) {
      return this.objectExists(route).pipe(tap(result => {
        if (!result) {
          this.router.navigate(['/404']);
        }
      }));
    } else {
      this.router.navigate(['/400']);
      return false;
    }
  }

  private objectExists(route: ActivatedRouteSnapshot) {
    return this.searchService.objectExists(route.params['type'], route.params['id']);
  }

  private hasRequiredParams(route: ActivatedRouteSnapshot): boolean {
    return route.params && route.params['id'] && route.params['type'];
  }


  private hasValidParams(route: ActivatedRouteSnapshot): boolean {
    return route.params['id'].length > 0 && route.params['type'].length > 0;
    // return Number.isInteger(+route.params['id']) && +route.params['id'] > 0 && route.params['type'].length > 0;
  }
}
